/* userGroup/reducer */
import { createReducer } from "typesafe-actions";
import { UserGroupActionTypes, UserGroupState } from "./types";
import { fetchRequest, fetchSuccess, fetchError } from "./actions";

export const initialState: UserGroupState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<UserGroupState, ActionType>(initialState)
  .handleType(UserGroupActionTypes.FETCH, (state) => {
    return { ...state, loading: true };
  })
  .handleType(UserGroupActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(UserGroupActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
